<template>
    <div>
        <Row type="flex" justify="space-between" align="middle" class="code-row-bg">
            <!-- tanggal bongkar -->
            <Col span="2">
            {{ invoiceDue.invoicedate | showDateFormatted }}
            </Col>
            <!-- desc -->
            <Col span="8">
            {{ invoiceDue.description }}
            </Col>

            <!-- total -->
            <Col span="2" align="right">
            {{ invoiceDue.invoicefee | currency }}
            </Col>

            <!-- tool tip kalo ? -->
            <Col span="1">
            <Tooltip v-show="invoiceDue.receivableDebitAmount != invoiceDue.invoicefee" placement="top">
                <Icon type="ios-help-outline"></Icon>
                <div slot="content">
                    <template>
                        Invoice Awal : {{ invoiceDue.receivableDebitAmount | currency }}
                    </template>
                </div>
            </Tooltip>
            </Col>

            <!-- sisa jika invoicefee sama dengan sisanya -->
            <template v-if="invoiceDue.invoicefee == invoiceDue.receivableRemaining">
                <Col span="2" align="right">
                {{ invoiceDue.receivableRemaining | currency }}
                </Col>
            </template>

            <!-- sisa jika invoicefee tidak sama dengan sisanya -->
            <template v-else>
                <Col span="2" align="right" style="color: red;">
                {{ invoiceDue.receivableRemaining | currency }}
                </Col>
            </template>

            <!-- tooltip ket selisih invoicefee dengan receivbale remaining -->
            <Col span="1">
            <Tooltip v-show="invoiceDue.receivableRemaining != invoiceDue.invoicefee" placement="top">

                <Icon type="ios-help-outline"></Icon>
                <div slot="content">
                    <!-- Total Bayar : {{ invoiceDue.receivableRemaining  | currency}} -->
                    Total Bayar : {{ invoiceDue.paymentSum | currency }}
                </div>
            </Tooltip>
            </Col>
            <Col span="5">

            <!-- allocate Amount -->
            <money v-model="allocateAmount" v-bind="money" class="ivu-input ivu-input-small">
            </money>
            <font color="red" v-show="invoiceDue.deviationAmount > 0">
                <span style="font-size: 12px">Overpayment: {{ invoiceDue.deviationAmount | currency }}</span>
            </font>

            <div v-show="depositRemaining > 0" style="margin-top:10px;">
                Deposit <money v-model="useDepositAmount" v-bind="money" class="ivu-input ivu-input-small"
                    style="width : 120px">
                </money>
            </div>
            </Col>
            <Col span="1">
            <Button-group size="small">
                <Button type="success" @click="toggleAllocateAll()">All</Button>
            </Button-group>
            </Col>
        </Row>
        <Row>
            <Col span="24">
            <br />
            <hr />
            </Col>
        </Row>
    </div>
</template>

<script>
import { Money } from 'v-money'
const numeral = require('numeral');
import moment from 'moment'


export default {
    props: {
        invoiceDue: Object,
        depositRemaining: Number
    },
    data: () => ({
        allocateAmount: 0,
        useDepositAmount: 0,
        money: {
            decimal: ',',
            thousands: '.',
            prefix: '',
            suffix: '',
            precision: 0,
            masked: false
        }
    }),
    components: { Money },
    methods: {
        toggleAllocateAll: function () {
            let receivableRemaining =
                this.invoiceDue.receivableRemaining - (this.allocateAmount + this.useDepositAmount)

            this.allocateAmount += receivableRemaining;
        },
        emitAllAmount: function () {
            // this.toggleAllocateAll();
            this.$emit('setAllocateAmount', this.invoiceDue)
        }

    },

    watch: {
        allocateAmount: function (newAllocateAmount) {
            this.invoiceDue.allocateAmount = _.parseInt(this.allocateAmount);
            this.emitAllAmount();
        },
        useDepositAmount: function (newUseDepositAmount) {
            this.invoiceDue.useDepositAmount = _.parseInt(this.useDepositAmount);
            this.emitAllAmount();
        }
    },

    filters: {
        currency: function (value) {
            if (!value) return ''
            return numeral(value).format('0,0')
        },
        showDateFormatted: function (stringToFormat) {
            let dateToFormat = moment(stringToFormat, 'YYYY-MM-DD').toDate();
            return moment(dateToFormat).format("DD MMM YYYY")
        }
    }
}

</script>
<style></style>



// WEBPACK FOOTER //
// cInvoicePaymentMutasi.vue?48c7b5d7